import stipulate, { resolveUrl } from 'stipulate';
import urlJoin from 'url-join';
import { baseUrl } from './base';

const listCustomHostnames = function (options) {
  if (!options.name) {
    throw new Error('Expected options.name to be set');
  }
  let url = urlJoin(baseUrl, '/pb/custom-hostnames/');
  if (options.apiUrl) {
    url = urlJoin(options.apiUrl, url);
  }
  const query = { name: options.name };
  url = resolveUrl(url, query);
  const fetchOptions = {
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
    }
  };
  return stipulate(url, fetchOptions);
};


export default listCustomHostnames;
